import { 
  MessageCircleQuestion,
  GraduationCap,
  FileChartColumn
} from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const features = [
  { 
    icon: <MessageCircleQuestion className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Quizzes and Tests",
    description: "AI-generated quizzes and practice questions (coming soon)."
  },
  { 
    icon: <GraduationCap className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Career Guidance",
    description: "Future career guidance based on performance and interests (coming soon)."
  },
  { 
    icon: <FileChartColumn className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Parent Surveys",
    description: "Feedback loops to refine study plans (coming soon)."
  }
];


export default function AiExpertTutor() {

    return (
        <Box
            badge={"Coming soon"}
            title={"AI Expert Tutor — Inside WhatsApp"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {features.map((member, index) => <MarktingCard key={"AiExpertTutor" + index} member={member} />)}
                    </div>
                </div>
            }
        />
    );
}